"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _get2 = _interopRequireDefault(require("@babel/runtime/helpers/get"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _action = _interopRequireDefault(require("./action"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

// FUTURE: enhance the Event Listener construct so that you can just specify a function inline?
// e.g.
//   actions: [
//     {
//       component: 'JavaScript',
//       function: () => 'foo'
//     }
//   ]
//
// could become:
//
//   actions: [
//     () => 'foo'
//   ]
//
//
// Behind the scenes, we'd probably want to convert these inline functions in JavaScript action
// objects so that they plug into the existing action constructs
var JavaScript = /*#__PURE__*/function (_Action) {
  (0, _inherits2.default)(JavaScript, _Action);

  var _super = _createSuper(JavaScript);

  function JavaScript() {
    var _this;

    (0, _classCallCheck2.default)(this, JavaScript);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_className", 'JavaScript');
    return _this;
  }

  (0, _createClass2.default)(JavaScript, [{
    key: "_create",
    value: function _create(props) {
      (0, _get2.default)((0, _getPrototypeOf2.default)(JavaScript.prototype), "_create", this).call(this, props);
      this.set({
        schema: {
          component: 'Form',
          fields: [{
            name: 'function',
            component: 'Field',
            required: true
          }]
        }
      });
    } // Note: this code is intentionally commented out as it introduces the risk of XSS attacks. This
    // code should REMAIN commented out in MSON, but is left here as something that can be enabled by
    // forks. It also serves as a reminder why we don't deserialize JS in MSON. See
    // https://github.com/redgeoff/mson/blob/main/DESIGN.md#why-doesnt-mson-support-custom-js-in-template-parameters
    // for a more in-depth explanation
    //
    // set(props) {
    //   if (props.function !== undefined && typeof props.function !== 'function') {
    //     // Note: use of `new Function` doesn't allow access to local scope:
    //     // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/Function
    //     props = {
    //       ...props,
    //       function: new Function(
    //         'props',
    //         `const f = ${props.function.toString()}; return f(props);`
    //       ),
    //     };
    //   }
    //
    //   super.set(props);
    // }

  }, {
    key: "act",
    value: function () {
      var _act = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(props) {
        var fun;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                fun = this.get('function');
                _context.next = 3;
                return fun(_objectSpread(_objectSpread({}, props), {}, {
                  globals: this._globals,
                  session: this._componentFillerProps._getSession(),
                  self: this // Use self instead of "this" as "this" is a reserved keyword

                }));

              case 3:
                return _context.abrupt("return", _context.sent);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function act(_x) {
        return _act.apply(this, arguments);
      }

      return act;
    }()
  }]);
  return JavaScript;
}(_action.default);

exports.default = JavaScript;